import styled from "styled-components";

export const CardContent = styled.div<{ flipped?: boolean }>`
  ${({ flipped }) =>
    flipped &&
    `
    transition: transform 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transform: rotateX(360deg);
  `}

  @media (min-width: 1921px) {
    border-radius: 8px;
    padding: 30px 56px;
    background: #f8f8f8;
    height: 118px;
    perspective: 1000px;
    font-weight: 800;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: -0.05em;

    ${({ flipped }) =>
      flipped &&
      `
          box-shadow: 0px 0px 22px 0px #00000026;

        `}

    .card {
      position: absolute;
      width: -webkit-fill-available;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 40px;
      padding-right: 56px;
      backface-visibility: hidden;

      .badge {
        width: 85px;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border: 1px solid #653cd5;
        border-radius: 23px;
        font-weight: bold;
        color: #653cd5;
        ${({ flipped }) =>
          flipped &&
          `
          background: #653cd5;
          color: #fff;
        `}
      }

      .content {
        width: 87%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: 800;
        font-size: 26px;
        line-height: 100%;
        letter-spacing: -0.05em;

        .left {
          width: 51%;
          display: flex;
          flex-direction: column;
          gap: 7px;
          text-align: left;

          .author {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .product {
            font-weight: 700;
            font-size: 22px;
            color: #5f5f5f;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .right {
          width: 49%;
          display: flex;
          flex-direction: row;
          font-weight: 300;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: -0.05em;

          .exhibition {
            width: 55%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            div:nth-child(2) {
              margin: 0 20px;
            }
          }

          .price {
            width: 80%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: relative;
            font-weight: 700;
            font-size: 24px;
            color: #000;
            align-items: center;

            .key {
              text-align: left;
            }

            .value {
              text-align: right;

              div:nth-child(2) {
                position: absolute;
                top: 25px;
                right: 0;
                font-weight: 300;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    border-radius: 8px;
    padding: 25px 39px;
    background: #f8f8f8;
    height: 108px;
    perspective: 1000px;
    ${({ flipped }) =>
      flipped &&
      `
          box-shadow: 0px 0px 22px 0px #00000026;

        `}

    .card {
      position: absolute;
      width: -webkit-fill-available;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 40px;
      padding-right: 39px;
      backface-visibility: hidden;

      .badge {
        width: 77px;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border: 1px solid #653cd5;
        border-radius: 23px;
        font-weight: bold;
        color: #653cd5;
        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        ${({ flipped }) =>
          flipped &&
          `
          background: #653cd5;
          color: #fff;
        `}
      }

      .content {
        width: 90%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: 800;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: -0.05em;

        .left {
          width: 52%;
          display: flex;
          flex-direction: column;
          gap: 10px;
          text-align: left;

          .author {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .product {
            font-weight: 700;
            font-size: 20px;
            color: #5f5f5f;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .right {
          width: 48%;
          display: flex;
          flex-direction: row;
          font-weight: 300;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: -0.05em;

          .exhibition {
            width: 55%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            div:nth-child(2) {
              margin: 0 20px;
            }
          }

          .price {
            width: 80%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: relative;
            font-weight: 700;
            font-size: 24px;
            color: #000;

            .key {
              text-align: left;
            }

            .value {
              text-align: right;

              div:nth-child(2) {
                position: absolute;
                top: 25px;
                right: 0;
                font-weight: 300;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    border-radius: 8px;
    padding: 21px 30px;
    background: #f8f8f8;
    height: 86px;
    perspective: 1000px;
    ${({ flipped }) =>
      flipped &&
      `
          box-shadow: 0px 0px 22px 0px #00000026;

        `}

    .card {
      position: absolute;
      width: -webkit-fill-available;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 28px;
      padding-right: 30px;
      backface-visibility: hidden;

      .badge {
        width: 70px;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border: 1px solid #653cd5;
        border-radius: 23px;
        font-weight: bold;
        color: #653cd5;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        ${({ flipped }) =>
          flipped &&
          `
          background: #653cd5;
          color: #fff;
        `}
      }

      .content {
        width: 90%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: 800;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.05em;

        .left {
          width: 54%;
          display: flex;
          flex-direction: column;
          gap: 4px;
          text-align: left;

          .author {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .product {
            font-weight: 700;
            font-size: 16px;
            color: #5f5f5f;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .right {
          width: 46%;
          display: flex;
          flex-direction: row;
          font-weight: 300;
          font-size: 12px;
          line-height: 100%;
          letter-spacing: -0.05em;

          .exhibition {
            width: 55%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            div:nth-child(2) {
              margin: 0 20px;
            }
          }

          .price {
            width: 80%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: relative;
            font-weight: 700;
            font-size: 20px;
            color: #000;

            .key {
              text-align: left;
            }

            .value {
              text-align: right;

              div:nth-child(2) {
                position: absolute;
                top: 21px;
                right: 0;
                font-weight: 300;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    border-radius: 8px;
    padding: 20px;
    background: #f8f8f8;
    height: 80px;
    perspective: 1000px;
    ${({ flipped }) =>
      flipped &&
      `
          box-shadow: 0px 0px 22px 0px #00000026;

        `}

    .card {
      position: absolute;
      width: -webkit-fill-available;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 18px;
      padding-right: 20px;
      backface-visibility: hidden;

      .badge {
        width: 64px;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border: 1px solid #653cd5;
        border-radius: 23px;
        font-weight: bold;
        color: #653cd5;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        ${({ flipped }) =>
          flipped &&
          `
          background: #653cd5;
          color: #fff;
        `}
      }

      .content {
        width: 88%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;

        .left {
          @media (min-width: 768px) and (max-width: 799px) {
            width: 40%;
          }
          @media (min-width: 800px) and (max-width: 900px) {
            width: 46%;
          }
          @media (min-width: 901px) and (max-width: 1000px) {
            width: 52%;
          }
          @media (min-width: 1001px) and (max-width: 1024px) {
            width: 57%;
          }
          display: flex;
          flex-direction: column;
          gap: 4px;
          text-align: left;

          .author {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .product {
            font-weight: 700;
            font-size: 14px;
            color: #5f5f5f;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .right {
          @media (min-width: 768px) and (max-width: 799px) {
            width: 60%;
          }
          @media (min-width: 800px) and (max-width: 900px) {
            width: 54%;
          }
          @media (min-width: 901px) and (max-width: 1000px) {
            width: 48%;
          }
          @media (min-width: 1001px) and (max-width: 1024px) {
            width: 43%;
          }
          display: flex;
          flex-direction: row;
          font-weight: 300;
          font-size: 12px;
          line-height: 100%;
          letter-spacing: -0.05em;

          .exhibition {
            width: 78%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            div:nth-child(2) {
              margin: 0 16px;
            }
          }

          .price {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: relative;
            font-weight: 700;
            font-size: 18px;
            color: #000;

            .key {
              text-align: left;
            }

            .value {
              text-align: right;

              div:nth-child(2) {
                position: absolute;
                top: 16px;
                right: 0;
                font-weight: 300;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    border-radius: 8px;
    background: #f8f8f8;
    height: 147px;
    perspective: 1000px;
    ${({ flipped }) =>
      flipped &&
      `
          box-shadow: 0px 0px 20px 0px #00000033;

        `}

    .card {
      position: relative;
      display: flex;
      padding: 25px 27px 25px 71px;
      width: 100%;

      .badge {
        width: 65px;
        height: 34px;
        width: 65;
        border-top-left-radius: 8px;
        border-bottom-right-radius: 19px;
        position: absolute;
        top: 0px;
        left: 0px;
        border: 1px solid #653cd5;
        color: #653cd5;
        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        ${({ flipped }) =>
          flipped &&
          `
          background: #653cd5;
          color: #fff;
        `};
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-weight: 800;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: -0.05em;
        width: 100%;

        .top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .author {
            text-align: left;
            width: 75%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .exhibition {
            text-align: right;
            font-weight: 300;
            font-size: 14px;
          }
        }

        .line {
          margin: 2px 0;
          border: 0.5px solid #bbbbbb;
        }

        .product {
          font-weight: 700;
          font-size: 20px;
          color: #5f5f5f;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
        }

        .price {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-weight: 700;
          font-size: 22px;
          color: #000;

          .key {
            text-align: left;
            font-weight: 700;
            font-size: 22px;
          }

          .value {
            text-align: right;
            font-weight: 300;
            font-size: 14px;
          }
        }
      }
    }
  }

  @media (max-width: 567px) {
    border-radius: 8px;
    background: #f8f8f8;
    height: 139px;
    perspective: 1000px;
    ${({ flipped }) =>
      flipped &&
      `
        box-shadow: 0px 0px 11px 0px #00000033;

        `}

    .card {
      position: relative;
      display: flex;
      padding: 12px 11px 20px 38px;
      width: 100%;

      .badge {
        width: 39px;
        height: 26px;
        border-top-left-radius: 8px;
        border-bottom-right-radius: 8px;
        position: absolute;
        top: 0px;
        left: 0px;
        border: 1px solid #653cd5;
        color: #653cd5;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        ${({ flipped }) =>
          flipped &&
          `
          background: #653cd5;
          color: #fff;
        `};
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        width: 100%;
        text-align: left;

        .exhibition {
          text-align: right;
          font-weight: 300;
          font-size: 12px;
        }

        .author {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .line {
          border: 0.5px solid #bbbbbb;
        }

        .product {
          font-weight: 700;
          font-size: 14px;
          color: #5f5f5f;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .price {
          font-weight: 800;
          font-size: 16px;
          color: #000;

          .key {
            font-weight: 800;
            font-size: 16px;
          }

          .value {
            font-weight: 300;
            font-size: 12px;
          }
        }
      }
    }
  }
`;
